<template>
  <div class="selector selector-order-by">
    <div>
      <ul ref="list">
        <li 
        v-for="o in orderBy.data" 
        :key="o.id"
        @click.prevent="update(o.id)" 
        :class="{active: o.id == orderBy.activeId}">
          <a href="#0"><span>{{o.name}}</span></a>
        </li>
        
<!--
<li @click.prevent="update({name: 'Più recente', id: 'per-data'})" :class="{active: orderBy.id == 'per-data'}">
  <a href="#0"><span>Più recente</span></a>
</li>
<li @click.prevent="update({name: 'Alfabetico', id: 'alfabetico'})" :class="{active: orderBy.id == 'alfabetico'}">
  <a href="#0"><span>Alfabetico</span></a>
</li>
-->

      </ul>
    </div>

  </div>
</template>

<script>
export default {
  props: ['orderBy'],
  data() {
    return {
    }
  },

  methods: {
    update: function(activeId) {
      this.$emit('update', {orderBy: {activeId}});
			
    }
  }
}
</script>

<style lang="scss" scoped>
@import './../css/variables.css';


  ul {
		@util reset-list;	
  }

  li {
    cursor: pointer;
		display: inline;
  }

  a {
		font-size: 12px;
    font-family: Arial, sans-serif;
		border-radius: 15px;
    padding: 3px 8px;
		transition: .3s;
		border: 1px solid transparent;
  }
	
	a:hover{
		border: 1px solid var(--azure);		
	}

  .active {
		
		a{
			background-color: var(--azure);
			border: 1px solid var(--azure);	
		}
  }
	
	.selector{
		display: inline-block;
	}
	
</style>


// WEBPACK FOOTER //
// src/vue/components/OrderBySelector.vue